export default __webpack_public_path__ + "static/media/dog-not-found.f1d5711c.png";